import { differenceInDays } from "date-fns";

import ButtonWizard from "componentsv2/button/ButtonWizard";
import CustomForm from "componentsv2/form/CustomForm";
import { AdjustmentsHorizontalIcon } from "components/Icons";
import { layout as layoutUpdate } from "./ModelUpdateFolio";
import { useWizard } from "storev2/wizardStore";
import { useStore } from "storev2/formStore";
import dates from "tools/dates";
import proxy from "api/proxy";

const icon = (
  <AdjustmentsHorizontalIcon className="h-5 w-5 fill-current my-auto" />
);

function UpdateFolio({ onClose, storeId, openModal }) {
  const { reset } = useWizard();
  const { findRecord } = useStore();

  async function handleUpdateFolio() {
    const { active: folio } = await findRecord(storeId);
    const { record } = useWizard.getState();
    const { store } = record;

    const values = {};

    for (const field of [
      "arrival_date",
      "departure_date",
      "room",
      "overbooking",
      "unit_price",
      "product",
    ]) {
      const value = store[field];
      if (value) {
        if (typeof value === "object") {
          values[field] = value.id;
        } else {
          values[field] = value;
        }
      }
    }

    if (store?.departure_date || store?.arrival_date) {
      const nights = getNights(
        store.arrival_date || folio?.arrival_date,
        store.departure_date || folio?.departure_date,
      );
      values.nights_quantity = nights;
    }
    const args = {
      model: "hotel.folio",
      ids: [folio.id],
      values: values,
      ctx: { overbooking: store.overbooking },
    };

    const { error } = await proxy.save(args);
    if (error) {
      console.log(error, "error");
      msgAlert.value = {
        show: true,
        text: error?.error,
        icon: "xmark",
        onClose: () => {
          msgAlert.value = { show: false };
        },
      };
      setButtonLoading(false);
      return false;
    }

    console.log("Actualizando reset...");
    reset();
    openModal.value = false;
    if (onClose) {
      onClose();
    }
  }

  function getNights(arrival, departure) {
    let arrival_date = arrival;
    let departure_date = departure;
    if (typeof arrival === "string") {
      arrival_date = dates.getTrytonDate2Js(arrival);
    }
    if (typeof departure_date === "string") {
      departure_date = dates.getTrytonDate2Js(departure);
    }
    return differenceInDays(departure_date, arrival_date);
  }

  return (
    <ButtonWizard
      label="hotel.folio.update"
      size="sm"
      styleBtn="border-teal-500 text-teal-700"
      openModal={openModal}
      icon={icon}
      onClose={onClose}
      buttons={[
        { name: "close", onClick: onClose },
        { name: "accept", onClick: handleUpdateFolio },
      ]}
    >
      <CustomForm
        key="hotel-folio-update"
        layout={layoutUpdate()}
        record={{}}
        parentRec={findRecord(storeId)}
      />
    </ButtonWizard>
  );
}

export default UpdateFolio;
